import { useSelector } from 'react-redux';
import { useParams } from '../../../../../../contexts/RouterContext';
import projectGrouping from '../../../../../../redux/project_grouping';

const useGetReleaseGroupIds = () => {
  const { projectGroupId } = useParams<{ projectGroupId: string }>();
  const release = useSelector(projectGrouping.selectors.getRelease);

  return {
    projectGroupId,
    releaseId: release.id,
  };
};

export default useGetReleaseGroupIds;
